import { Choice } from './choice';
import { Consent } from './consent';
import { DateComponent } from './date';
import { Dropdown } from './dropdown';
import { Email } from './email';
import { File } from './file';
import { Heading } from './heading';
import { Hidden } from './hidden';
import { ImageChoice } from './image-choice';
import { LongText } from './long-text';
import { NumberComponent } from './number-form';
import { NumberScale } from './number-scale';
import { Paragraph } from './paragraph';
import { Phone } from './phone';
import { ShortText } from './short-text';
import { Signature } from './signature';
import { Slider } from './slider';
import { SmileyScale } from './smiley-scale';
import { StarScale } from './star-scale';
import { ThumbScale } from './thumb-scale';
import { Time } from './time';
import { URL } from './URL';

export const fieldComponents = {
  choice: Choice,
  number: NumberComponent,
  imageChoice: ImageChoice,
  heading: Heading,
  dropdown: Dropdown,
  consent: Consent,
  email: Email,
  shortText: ShortText,
  slider: Slider,
  hidden: Hidden,
  phone: Phone,
  longText: LongText,
  date: DateComponent,
  signature: Signature,
  file: File,
  label: () => null,
  numberScale: NumberScale,
  paragraph: Paragraph,
  smileyScale: SmileyScale,
  starScale: StarScale,
  thumbScale: ThumbScale,
  time: Time,
  URL: URL
} as const;
